"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.person = void 0;
exports.person = {
    path: "M10 3.33333C8.15834 3.33333 6.66668 4.82499 6.66668 6.66666C6.66668 8.50833 8.15834 9.99999 10 9.99999C11.8417 9.99999 13.3333 8.50833 13.3333 6.66666C13.3333 4.82499 11.8417 3.33333 10 3.33333ZM11.6667 6.66666C11.6667 5.74999 10.9167 4.99999 10 4.99999C9.08334 4.99999 8.33334 5.74999 8.33334 6.66666C8.33334 7.58333 9.08334 8.33333 10 8.33333C10.9167 8.33333 11.6667 7.58333 11.6667 6.66666ZM15 14.1667C14.8333 13.575 12.25 12.5 10 12.5C7.75001 12.5 5.16668 13.575 5.00001 14.175V15H15V14.1667ZM3.33334 14.1667C3.33334 11.95 7.77501 10.8333 10 10.8333C12.225 10.8333 16.6667 11.95 16.6667 14.1667V16.6667H3.33334V14.1667Z",
    originalWidth: 20,
    originalHeight: 20,
    basicColor: "tableGray1",
    activeColor: "tableBlack2"
};
